export default "__VITE_ASSET__DINtN9sw__"